import { useEffect, useRef, useState } from "react";
import { PointPaidDto } from "../../../../../../../solution/components/point-paid";
import { usePointPaid } from "../../../../../../../solution/components/point-paid/hook/usePointPaid";
import * as S from "../../styles";
import { TimerControllerDropBox } from "../../../../../../style";

interface Props {
  item: PointPaidDto;
  index: number;
  isGtd: boolean;
  hook: ReturnType<typeof usePointPaid>;
}

const getPaidSum = (prizeItem: PointPaidDto) => {
  return (
    (prizeItem.seedPrize || 0) +
    (prizeItem.pointPrize || 0) +
    (prizeItem.carrotPrize || 0) +
    (prizeItem.subPrize?.prizeValue || 0) * (prizeItem.subPrizeCount || 0)
  );
};

const MobileTimerControllerPrizeItem = ({
  item,
  index,
  isGtd,
  hook,
}: Props) => {
  const {
    allPrizeList,
    setAllPrizeList,
    subPrizeList,
    handleUserPointReset,
    handleUserPointPay,
    handleNicknameClick,
    setLocalStorage,
    setSelectRank,
    selectRank,
  } = hook;
  const [totalPrize, setTotalPrize] = useState(item.totalPrize);
  const [pointPrize, setPointPrize] = useState(item.pointPrize || 0);
  const [carrotPrize, setCarrotPrize] = useState(item.carrotPrize || 0);
  const [seedPrize, setSeedPrize] = useState(item.seedPrize || 0);
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (selectRank === index) {
      const timer = setTimeout(() => {
        elementRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [selectRank, index]);

  useEffect(() => {
    setTotalPrize(item.totalPrize);
    setPointPrize(item.pointPrize || 0);
    setCarrotPrize(item.carrotPrize || 0);
    setSeedPrize(item.seedPrize || 0);
  }, [item]);

  const handleButtonClick = () => {
    if (item.payMent) {
      handleUserPointReset(item);
      return;
    }

    const nextItem = {
      ...item,
      seedPrize: seedPrize || 0,
      carrotPrize: carrotPrize || 0,
      pointPrize: pointPrize || 0,
    };

    if (getPaidSum(nextItem) !== nextItem.totalPrize) {
      alert(
        "매장이용권 + 캐럿 + 래빗 + 부상 합계가 토탈 프라이즈와 일치해야 합니다.",
      );
      return;
    }

    const list = [...allPrizeList];
    list[index] = nextItem;
    setAllPrizeList(list);
    handleUserPointPay(nextItem);
  };

  // 부상 드롭다운 토글
  const handleSubPrizeDropdown = () => {
    if (item.payMent) return;
    const newList = allPrizeList.map((item, idx) => ({
      ...item,
      isOpenSubPrize: idx === index ? !item.isOpenSubPrize : false,
    }));
    setAllPrizeList(newList);
  };

  // 부상 선택 핸들러
  const handleSubPrizeSelect = (subPrize: any) => {
    const list = [...allPrizeList];
    list[index].subPrize = subPrize; // 부상 저장
    list[index].subPrizeCount = 0;
    setAllPrizeList(list);
  };

  // 부상 개수 조절 핸들러
  const handleSubPrizeCount = (isAdd: boolean) => {
    if (!item.subPrize || item.payMent) return;

    const count = isAdd ? 1 : -1;
    const editCount = item.subPrizeCount + count;
    if (editCount < 0) return;

    const selectedSubPrize = item.subPrize?.prizeValue || 0;
    if (editCount * selectedSubPrize > item.totalPrize) {
      alert("기존 시상 수량보다 크게 설정할 수 없습니다.");
      return;
    }

    const list = [...allPrizeList];
    list[index].subPrizeCount = editCount;
    setAllPrizeList(list);
  };

  return (
    <S.MobileControllerPrizeItemWrapper
      $isPayment={item.payMent}
      onClick={() => {
        setSelectRank(selectRank === index ? null : index);
        if (selectRank === index) {
          const newList = allPrizeList.map((i) => ({
            ...i,
            isOpenSubPrize: false,
          }));
          setAllPrizeList(newList);
        }
      }}
      ref={elementRef}
    >
      <S.MobileControllerPrizeItemSummary>
        <S.MobileControllerPrizeItemSummaryLeft $isPayment={item.payMent}>
          <div className="rank">{item.rank}위</div>
          <div className="name">
            {item.payMent && (
              <img src="/image-web/controller/m-check.svg" alt="payment" />
            )}
            {item.nickname ?? "시상대기"}
          </div>
        </S.MobileControllerPrizeItemSummaryLeft>
        <S.MobileControllerPrizeItemSummaryRight $isOpen={selectRank === index}>
          <div className="rank">{item.totalPrize} PRIZE</div>
          <img src="/image-web/controller/drop_down.svg" alt="drop_down" />
        </S.MobileControllerPrizeItemSummaryRight>
      </S.MobileControllerPrizeItemSummary>
      <S.MobileControllerPrizeItemDetail
        id={`prize-item-${index}`}
        $isOpen={selectRank === index}
        onClick={(e) => e.stopPropagation()}
      >
        <S.MobileControllerPrizeItemDetailRowWrapper>
          <S.MobileControllerPrizeItemDetailRow $isPayment={item.payMent}>
            <div className="name">토탈 프라이즈{isGtd && "(+추가시상)"}</div>
            {isGtd ? (
              <input value={item.totalPrize.toLocaleString()} disabled />
            ) : (
              <input
                value={totalPrize}
                inputMode="numeric"
                onChange={(e) => {
                  const prizes = [...allPrizeList];
                  prizes[index].totalPrize = +e.target.value;
                  setAllPrizeList(prizes);
                  setLocalStorage(prizes);
                  setTotalPrize(+e.target.value);
                }}
                disabled={item.payMent}
              />
            )}
          </S.MobileControllerPrizeItemDetailRow>
          <S.MobileControllerPrizeItemDetailRow $isPayment={item.payMent}>
            <div className="name">매장이용권</div>
            <input
              value={pointPrize}
              inputMode="numeric"
              onChange={(e) => {
                const prizes = [...allPrizeList];
                prizes[index].pointPrize = +e.target.value;
                setAllPrizeList(prizes);
                setLocalStorage(prizes);
                setPointPrize(+e.target.value);
              }}
              disabled={item.payMent}
            />
          </S.MobileControllerPrizeItemDetailRow>
          <S.MobileControllerPrizeItemDetailRow $isPayment={item.payMent}>
            <div className="name">캐럿</div>
            <input
              value={carrotPrize}
              inputMode="numeric"
              onChange={(e) => {
                const value = +e.target.value;
                if (Number.isNaN(value) || value < 0) return;
                const prizes = [...allPrizeList];
                prizes[index].carrotPrize = value;
                setAllPrizeList(prizes);
                setLocalStorage(prizes);
                setCarrotPrize(value);
              }}
              disabled={item.payMent}
            />
          </S.MobileControllerPrizeItemDetailRow>
          <S.MobileControllerPrizeItemDetailRow $isPayment={item.payMent}>
            <div className="name">부상 선택</div>
            <div className="box" onClick={handleSubPrizeDropdown}>
              {item?.subPrize?.name || "부상 선택"}
              <img src="/image-web/controller/drop_down.svg" alt="down" />
              {item.isOpenSubPrize && (
                <TimerControllerDropBox top="110%" width="100%">
                  <div
                    className={`item ${item.subPrize === null ? "selected" : ""}`}
                    onClick={() => handleSubPrizeSelect(null)}
                  >
                    부상 선택
                  </div>
                  {subPrizeList.map((subPrize) => (
                    <div
                      key={subPrize.id}
                      className={`item ${item.subPrize === subPrize ? "selected" : ""}`}
                      onClick={() => handleSubPrizeSelect(subPrize)}
                    >
                      {subPrize.name}
                    </div>
                  ))}
                </TimerControllerDropBox>
              )}
            </div>
          </S.MobileControllerPrizeItemDetailRow>
          <S.MobileControllerPrizeItemDetailRow $isPayment={item.payMent}>
            <div className="name">부상 갯수</div>
            <S.MobileControllerPrizeItemDetailRowCount
              $isPayment={item.payMent}
            >
              <div
                className="button"
                onClick={() => handleSubPrizeCount(false)}
              >
                <img src="/image-web/icon/minus.svg" alt="minus" />
              </div>
              <div className="count">{item.subPrizeCount ?? 0}</div>
              <div className="button" onClick={() => handleSubPrizeCount(true)}>
                <img src="/image-web/icon/plus.svg" alt="plus" />
              </div>
            </S.MobileControllerPrizeItemDetailRowCount>
          </S.MobileControllerPrizeItemDetailRow>
          <S.MobileControllerPrizeItemDetailRow $isPayment={item.payMent}>
            <div className="name">래빗</div>
            <input
              value={seedPrize}
              inputMode="numeric"
              onChange={(e) => {
                const value = +e.target.value;
                if (Number.isNaN(value) || value < 0) return;
                const prizes = [...allPrizeList];
                prizes[index].seedPrize = value;
                setAllPrizeList(prizes);
                setLocalStorage(prizes);
                setSeedPrize(value);
              }}
              disabled={item.payMent}
            />
          </S.MobileControllerPrizeItemDetailRow>
          <S.MobileControllerPrizeItemDetailRow $isPayment={true}>
            <div className="name">닉네임 검색</div>
            <div
              className={item.nickname ? "nickname" : "box"}
              onClick={() => {
                if (item.payMent) return;
                handleNicknameClick(index);
              }}
            >
              {item.nickname ?? "닉네임 검색"}
              {!item.nickname && (
                <img src="/image-web/icon/search.svg" alt="search" />
              )}
            </div>
          </S.MobileControllerPrizeItemDetailRow>
        </S.MobileControllerPrizeItemDetailRowWrapper>
        <S.MobileControllerPrizeItemButton
          $isPayment={item.payMent}
          onClick={handleButtonClick}
        >
          {item.payMent ? "지급 취소" : "지급"}
        </S.MobileControllerPrizeItemButton>
      </S.MobileControllerPrizeItemDetail>
    </S.MobileControllerPrizeItemWrapper>
  );
};

export default MobileTimerControllerPrizeItem;
